import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import axios, { AxiosResponse } from 'axios'
import { clearAllData, clearSession, useAppDispatch } from 'store'
import i18n from 'utils/i18n'

const request = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
  headers: {
    common: {
      'Content-Type': 'application/json',
      'x-app-id': process.env.REACT_APP_CLIENT_ID
    }
  }
})

interface ErrorData {
  code: string
  message: string
}

const AxiosInterceptor = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const resInterceptor = (response: AxiosResponse) => {
      return response
    }

    const errInterceptor = (error: any) => {
      if (error.response?.status === 401) {
        const data = JSON.parse(`${error.response?.data?.message}`) as unknown as ErrorData

        if (data?.code === 'InSufficientPermission') {
          navigate('/adaptive-authentication/email')
          return
        }
        dispatch(clearAllData())
        dispatch(clearSession())
        navigate('/dashboard/intro', { replace: true })
      }

      return Promise.reject(error)
    }

    const reqInterceptor = request.interceptors.request.use((config) => {
      config.headers['x-locale'] = i18n.language
      return config
    })

    const interceptor = request.interceptors.response.use(resInterceptor, errInterceptor)

    return () => {
      request.interceptors.request.eject(reqInterceptor)
      request.interceptors.response.eject(interceptor)
    }
  }, [dispatch, navigate])

  return <Outlet />
}

export default request
export { AxiosInterceptor }
